import React from 'react';

export default function IconPlaylist(
  props: React.SVGAttributes<SVGSVGElement>
) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M13.8791 0C14.3882 0 14.788 0.412075 14.788 0.908969C14.788 1.41811 14.388 1.81794 13.8791 1.81794H6.10953C5.61264 1.81794 5.20056 1.41789 5.20056 0.908969C5.20056 0.412075 5.61264 0 6.10953 0H13.8791Z" />
      <path d="M17.0177 3.63626C17.0177 4.1454 16.6057 4.54523 16.1088 4.54523H3.89078C3.38164 4.54523 2.98181 4.14518 2.98181 3.63626C2.98181 3.13937 3.38187 2.7273 3.89078 2.7273H16.1088C16.6057 2.72707 17.0177 3.13915 17.0177 3.63626Z" />
      <path d="M0.000222607 8.78768C0.000222607 6.9575 1.49113 5.45435 3.33356 5.45435H16.6667C18.5091 5.45435 20 6.95727 20 8.78768V16.6663C20 18.5087 18.5091 19.9996 16.6667 19.9996H3.33333C1.49091 19.9996 0 18.5087 0 16.6663V8.78768H0.000222607ZM16.6667 7.27273H3.33333C2.49694 7.28475 1.81816 7.95151 1.81816 8.7879V16.6665C1.81816 17.5029 2.49694 18.1817 3.33333 18.1817H16.6664C17.5028 18.1817 18.1816 17.5029 18.1816 16.6665V8.7879C18.1816 7.95151 17.5028 7.28475 16.6667 7.27273Z" />
    </svg>
  );
}
